import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";


const IconsWithButton = ({ blok }) => (
  <div className="">
    <div
      className="iconswithbutton-wrap"
      {...storyblokEditable(blok)}
    >
      <div className="iconswithbutton-outer">
        <h2 className="iconswithbutton-subheadline text-6xl">
          {blok.headline}
        </h2>
        <h2 className="iconswithbutton-subheadline text-6xl">
          {blok.headline2}
        </h2>

        <div className="iconswithbutton-content-outer">

          <div className="iconswithbutton-content">
            <img
              className="iconswithbutton-image"
              src="/src/icons/Qualitaet_und_Expertise.png"
              alt="Qualität_und_Expertise"
            />
            <h3>{blok.subheadline1}</h3>
            <p>{blok.text1}</p>
          </div>

          <div className="iconswithbutton-content">
            <img
              className="iconswithbutton-image"
              src="/src/icons/Technik_und_Ausstattung.png"
              alt="Technik_und_Ausstattung"
            />
            <h3>{blok.subheadline2}</h3>
            <p>{blok.text2}</p>
          </div>

          <div className="iconswithbutton-content">
            <img
              className="iconswithbutton-image"
              src="/src/icons/Starke_Markenvielfalt.png"
              alt="Starke_Markenvielfalt"
            />
            <h3>{blok.subheadline3}</h3>
            <p>{blok.text3}</p>
          </div>

          <div className="iconswithbutton-content">
            <img
              className="iconswithbutton-image"
              src="/src/icons/Marketing_Business_Support.png"
              alt="Marketing_Business_Support"
            />
            <h3>{blok.subheadline4}</h3>
            <p>{blok.text4}</p>
          </div>

          <div className="iconswithbutton-content">
            <img
              className="iconswithbutton-image"
              src="/src/icons/Partnerschaft_auf_Augenhoehe.png"
              alt="Partnerschaft_auf_Augenhöhe"
            />
            <h3>{blok.subheadline5}</h3>
            <p>{blok.text5}</p>
          </div>

          <div className="iconswithbutton-content">
            <img
              className="iconswithbutton-image"
              src="/src/icons/Netzwerk_und_Chancen.png"
              alt="Netzwerk_und_Chancen"
            />
            <h3>{blok.subheadline6}</h3>
            <p>{blok.text6}</p>
          </div>
        </div>

        <div className="textwithbuttonintro-button">
          {blok.link && (
            <Link href={blok.link} >
              <button>{blok.button}</button>
            </Link>
          )}
          {blok.linknewtab && (
            <Link target="_blank" href={blok.linknewtab} >
                <button>{blok.buttonnewtab}</button>
            </Link>
          )}
        </div>
      </div>
    </div>
  </div>
);
export default IconsWithButton;
